export default {
  links: {},
  currentFolder: {
    ancestors: [],
  },
  nodesLoading: true,
  isMovingOnlyFolders: false,
};
